mutation DuplicateStagesetForModal($input: DuplicateStagesetInput!) {
    duplicateStageset(input: $input) {
        stageset {
            id
            name
            htmlUrlPath
        }
    }
}
